<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title mb-0">{{title}}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="formKeyboard">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="keyboardPassword" class="col-form-label">{{'@direction.pages.student.modalKeyboard.password' | translate }}</label>
            <input type="password" class="form-control" id="keyboardPassword" maxlength="4" formControlName="keyboardPassword">
            <mat-error class="pt-1">
              <ds-control-validation [control]="formKeyboard.get('keyboardPassword')" [validators]="this.validators.keyboardPassword">
              </ds-control-validation>
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="repeatPassword" class="col-form-label">{{'@direction.pages.student.modalKeyboard.repeatPassword' | translate
              }}</label>
            <input type="password" class="form-control" id="repeatPassword" maxlength="4" formControlName="repeatPassword">
            <mat-error class="pt-1">
              <ds-control-validation [control]="formKeyboard.get('repeatPassword')" [validators]="this.validators.repeatPassword">
              </ds-control-validation>
            </mat-error>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!formKeyboard.valid" data-bs-dismiss="modal"
      (click)="onConfirm()">{{'@direction.pages.student.modalKeyboard.buttonSend' | translate }}</button>
  </div>
</div>
